import { ReactComponent as PlanIcon } from 'assets/icons/dock_article.svg'
import { ReactComponent as SlidesIcon } from 'assets/icons/slideshow.svg'

const RESOURCE_CONFIG = [
	{ key: 'plan', label: 'Plan', Icon: PlanIcon },
	{ key: 'slides', label: 'Slides', Icon: SlidesIcon },
]

export default function useResourceActionsCurriculum(resources = {}) {
	const resourceMap = resources && typeof resources === 'object' ? resources : {}

	const items = RESOURCE_CONFIG.filter(resource => {
		const url = resourceMap[resource.key]
		return Boolean(url && String(url).trim())
	}).map(resource => ({
		...resource,
		url: String(resourceMap[resource.key]).trim(),
	}))

	const handleResourceClick = (resourceKey, onResourceClick) => {
		onResourceClick?.(resourceKey)
	}

	return {
		resources: items,
		hasResources: items.length > 0,
		handleResourceClick,
	}
}
